import ButtonFill from '@components/ButtonFill';
import {store, actions} from '@components/Test/Context';
import DefaultBinaryResult from '@components/Test/DefaultBinaryResult';
import Progress from '@components/Test/Progress';
import Question from '@components/Test/Question';
import Result from '@components/Test/Result';
import {BINARY} from '@constants/test';
import type {
    Result as ResultType,
    Question as QuestionType,
    Progress as ProgressType,
} from '@interfaces/Test';
import type {ReactElement} from 'react';
import {useContext, useEffect, useState} from 'react';

interface Props {
    progress: ProgressType;
    questions: QuestionType[];
    results: ResultType[];
}

export default function TestManager(props: Props): ReactElement<Props> {
    const {currentState, dispatch} = useContext(store);
    const [result, setResult] = useState<ResultType | undefined>(props.results[0]);

    useEffect(() => {
        const finalResult = props.results
            .sort((a, b) => b.min - a.min)
            .find((item: ResultType) => item.min <= currentState.score);
        if (finalResult) {
            setResult(finalResult);
        }
    }, [currentState.isComplete]);

    function handleClick() {
        if (currentState.isChecked && hasNextQuestion()) {
            dispatch({type: actions.nextQuestion});
        }
        if (currentState.isChecked && !hasNextQuestion()) {
            dispatch({type: actions.complete});
        }
    }

    function hasNextQuestion() {
        return currentState.questionNum + 1 < props.questions.length;
    }

    return (
        <div>
            {!currentState.isComplete && (
                <div className="test-question">
                    <div className="test-question__number">
                        {currentState.questionNum + 1}/{props.questions.length}
                    </div>
                    <Question
                        key={currentState.questionNum}
                        {...props.questions[currentState.questionNum]}
                    >
                        {() =>
                            currentState.showProgress ? <Progress {...props.progress} /> : null
                        }
                    </Question>
                    <ButtonFill
                        type="button"
                        className="test-question__button"
                        onClick={handleClick}
                    >
                        Дальше
                    </ButtonFill>
                </div>
            )}
            {currentState.isComplete && result ? (
                <Result maxScore={props.questions.length} {...result} />
            ) : null}
            {currentState.isComplete && !result && currentState.type === BINARY ? (
                <DefaultBinaryResult maxScore={props.questions.length} />
            ) : null}
        </div>
    );
}
